import { SafetyOutlined } from '@ant-design/icons'
import { Button, Modal, Select } from 'antd'
import React from 'react'
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';

const DerogationUtilisateur = ({ utilisateur, requireActive, infoButtonStyle, habilitations, navigate, param, modules, isSecurityLocked, securityLockMessage }) => {
    const [derogationModalOpen, setDerogationModalOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [selectedHabilitations, setSelectedHabilitations] = React.useState([]);
    const [dateFinDerogation, setDateFinDerogation] = React.useState(null);
    const isDisabled = !utilisateur?.active || isSecurityLocked;
    const disabledButtonStyle = {
        backgroundColor: '#E5E7EB',
        borderColor: '#E5E7EB',
        color: '#9CA3AF',
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
    };

    const handleSelectChange = (value) => {
        let selectedHabs = [];
        value.forEach((el) => {
            let h = habilitations.find((e) => e.habilitationId === parseInt(el));
            selectedHabs.push(h);
        });
        setSelectedHabilitations(selectedHabs);
    };


    // Fonction qui filtre les habilitations afin de ressortir celles d'un module spécifique défini par son moduleId
    const getHabilitationsOfModule = (moduleId) => {
        let habs = habilitations.filter((e) => e.module.moduleId === moduleId);
        let opt = [];
        let habbs = habs.filter(
            (e) =>
                !utilisateur?.profil?.habilitations.some(
                    (f) => f.habilitationId === e.habilitationId
                )
        );
        habbs.forEach((hab, id) => {
            opt.push({
                key: id,
                label: hab.libelle,
                value: hab.habilitationId,
            });
        });
        return opt;
    };

    const getUpdateHabilitationsOfModule = (moduleId) => {
        let habs = selectedHabilitations.filter(
            (e) => e.module.moduleId === moduleId
        );
        // console.log("habits...: ", habs);
        let opt = [];
        habs.forEach((hab, id) => {
            opt.push({
                key: id,
                label: hab.libelle,
                value: hab.habilitationId,
            });
        });
        return opt;
    };

    const onSubmit = () => {
        if (requireActive("octroyer une dérogation")) return;
        if (isSecurityLocked) {
            toast(securityLockMessage || "Action non autorisée.");
            return;
        }
        setLoading(true);
        utilisateur.derogation = selectedHabilitations;
        utilisateur.dateFinDerogation = `${dateFinDerogation}T23:59:59.0`;
        // console.log("Utilisateur: ", utilisateur);
        axiosInstance
            .put(`/api/utilisateur/derogation`, JSON.stringify(utilisateur))
            .then((res) => {
                // console.log(res.data);
                setLoading(false);
                setDerogationModalOpen(false);
                navigate(`/details-utilisateur/${res.data.codeId}`, { replace: true });
                toast("Dérogation octroyée avec succès");
            })
            .catch((err) => {
                console.log(err);
                toast("Erreur lors de l'octroi de la dérogation");
                setLoading(false);
            });
    };


    return (
        <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '24px',
            border: '2px solid #E6F0FF',
            transition: 'all 0.3s ease'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    backgroundColor: '#E6F0FF',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <SafetyOutlined style={{ fontSize: '24px', color: '#242166' }} />
                </div>
                <div>
                    <h4 style={{ fontSize: '16px', fontWeight: '600', color: '#242166', margin: 0 }}>
                        Dérogation
                    </h4>
                    <p style={{ fontSize: '12px', color: '#6B7280', margin: 0 }}>
                        Permissions temporaires
                    </p>
                </div>
            </div>
            <p style={{ fontSize: '14px', color: '#6B7280', marginBottom: '16px' }}>
                Accordez des permissions spéciales temporaires à l'utilisateur
            </p>
            {securityLockMessage && (
                <p style={{ fontSize: '12px', color: '#b45309', marginBottom: '12px' }}>
                    {securityLockMessage}
                </p>
            )}
            <Button
                icon={<SafetyOutlined />}
                block
                onClick={() => {
                    if (isSecurityLocked) {
                        toast(securityLockMessage || "Action non autorisée.");
                        return;
                    }
                    setDerogationModalOpen(true);
                }}
                disabled={isDisabled}
                style={isDisabled ? { ...infoButtonStyle, ...disabledButtonStyle } : infoButtonStyle}
            >
                Octroyer une dérogation
            </Button>

            <Modal
                open={derogationModalOpen && !isSecurityLocked}
                onCancel={() => setDerogationModalOpen(false)}
                zIndex={2000}
                centered
                onOk={onSubmit}
                loading={loading}
            >
                <form id="addNewAddressForm" className="row g-12" onSubmit={onSubmit}>
                    <div className="col-12 col-md-12">
                        <div className="text-center">
                            <p className="address-subtitle">
                                Octroyer une dérogation à{" "}
                                <b>
                                    {utilisateur?.personne?.nom} {utilisateur?.personne?.prenom}
                                </b>
                            </p>
                        </div>
                        {/* <br /> */}
                        <div class="row">
                            {modules?.map((mod, id) => (
                                <div class="col-md-12 select2-primary" key={id}>
                                    <label class="form-label" for="formtabs-language">
                                        {mod?.nom}
                                    </label>
                                    <Select
                                        mode="multiple"
                                        style={{
                                            width: "100%",
                                        }}
                                        placeholder="Veuillez sélectionner les habilitations spéciales sur le module"
                                        onChange={handleSelectChange}
                                        options={getHabilitationsOfModule(mod.moduleId)}
                                        defaultValue={
                                            param.profilId
                                                ? getUpdateHabilitationsOfModule(mod.moduleId)
                                                : []
                                        }
                                        value={getUpdateHabilitationsOfModule(mod.moduleId)}
                                    />
                                </div>
                            ))}
                        </div>
                        <hr />
                        <div class="col-md-12 col-12">
                            <label for="flatpickr-datetime" class="form-label">
                                Date de fin de dérogation
                            </label>
                            <input
                                type="date"
                                class="form-control"
                                placeholder="YYYY-MM-DD HH:MM"
                                id="flatpickr-datetime"
                                onChange={(e) => setDateFinDerogation(e.target.value)}
                            />
                        </div>
                    </div>
                </form>
                {/* </Modal.Body> */}
            </Modal>
        </div>
    )
}

export default DerogationUtilisateur
